module.exports = __webpack_public_path__ + "img/01.a9a8832c.jpg";